import { isbot } from 'isbot';

const isAutomatedBrowser = (userAgent: string, webdriver: boolean) =>
	webdriver || /headlesschrome|puppeteer|playwright|phantomjs/i.test(userAgent);

/**
 * True for crawlers, previewers and headless/automated browsers, which are excluded
 * from all Datadog reporting (INF-3580). Arguments are injectable for testing.
 */
export const isBotUserAgent = (
	userAgent: string = navigator.userAgent,
	webdriver: boolean = navigator.webdriver ?? false,
): boolean => {
	// isbot('') is false, but a real browser always sends a user agent.
	if (!userAgent) return true;
	return isbot(userAgent) || isAutomatedBrowser(userAgent, webdriver);
};
